export default 'https://tme.understood.org/assets/wood.fef0ac0e.jpg'